import { Button } from "react-bootstrap";
import { SideNavButton } from "../../components_new/navigator/off-canvas";
import { AdminCan } from "../../components_new/permission/can";
import { useStore } from "../../hooks-store/store";
import { useNavigate } from "react-router-dom";
import { Timer } from "../../components_new/timer/timer";
import { useContext, useEffect, useState } from "react";
import { ReportingContext } from "./home";
import { getLink, sendCallToAPI } from "../../common/generic_functions";
import { links } from "../login/links";

export const HeaderNav = () => {
  return (
    <>
      <div style={{ display: "flex", flexDirection: "row", alignItems: "center", gap: "1rem"}}>
        <div>
          <SideNavButton />
        </div>
       <b style={{"color": "#807f7e"}}><WorkSpaceName /></b> 
      </div>
      <div style={{ display: "flex", justifyContent: "center", gap: "1rem" }}>
        <TokenTimer />
        <AdminCan>
          <AdminButton />
        </AdminCan>
        <LogOutButton />
      </div>
    </>
  );
};

const WorkSpaceName = () => {
  const { getCurrentWorkSpaceName, getReportName, getCurrentWorkSpace } = useContext(ReportingContext);
  const [label, setLabel] = useState(getCurrentWorkSpaceName());
  const [reportName, setReportName] = useState();
  const navigate = useNavigate();
  const navigateToWorkspace = () => {
    navigate("/" + getCurrentWorkSpace() + "/");
  };
  useEffect(() => {
    let curr = getCurrentWorkSpaceName();
    let name = getReportName();
    setReportName(name);
    setLabel(curr);
  }, [getCurrentWorkSpaceName, getReportName]);
  let secondName = reportName ? (
    <>
    {"➜"}
      <label>{reportName}</label>
    </>
  ) : (
    <></>
  );
  return (
    <>
      <label style={{ cursor: "pointer" }} onClick={() => navigateToWorkspace()}>
        {label}
      </label>
      {secondName}
    </>
  );
};

const TokenTimer = () => {
  const { expirationTime } = useContext(ReportingContext);
  if (!expirationTime) {
    return <></>;
  }
  return (
    <Button className="nav-wrapper" variant="outline-secondary" style={{ verticalAlign: "sub" }}>
      <div className="tokentimer">
        <div>
          <span className="material-symbols-outlined nav-button">timer</span>
        </div>
        <Timer targetDateTime={expirationTime} />
      </div>
    </Button>
  );
};

const AdminButton = () => {
  return (
    <Button className="nav-wrapper" variant="outline-primary" style={{ verticalAlign: "sub" }}>
      <span className="material-symbols-outlined nav-button">admin_panel_settings</span>
      <label style={{ fontSize: "14px", cursor: "pointer" }}>Admin Panel</label>
    </Button>
  );
};

const LogOutButton = () => {
  const [store, dispatch] = useStore();
  const navigate = useNavigate();

  const logout = () => {
    const link = getLink("", links, "logout");
    const accessToken = store.accessToken;
    sendCallToAPI(link, accessToken, {}, "POST");
    dispatch("CLEAR_DATA");
    document.cookie = "auth_token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
    navigate("/login");
  };

  return (
    <div>
      <Button className="nav-wrapper" variant="outline-primary" onClick={() => logout()}>
        <div>
          <span className="material-symbols-outlined nav-button">logout</span>
        </div>
      </Button>
    </div>
  );
};
